
import Lottie from "lottie-react";
import animationData from '../images/loading/animation_500_loading.json'

const ProgressWaiting = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div className={'  fixed z-50 inset-0 overflow-y-auto  '}  aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div className="flex items-end justify-center lg:max-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 bg-white bg-opacity-80 " aria-hidden="true"></div>

      <span className="hidden sm:inline-block align-middle h-screen " aria-hidden="true">&#8203;</span>
  
      <div className="inline-block rounded-lg p-2 text-left   overflow-hidden transform transition-all  align-middle ">

          <Lottie animationData={animationData} loop={true}   height={150}
              width={150} />
      </div>
    </div>
</div>   
  )
}

export default ProgressWaiting